import React from 'react'
import './Footer.css'
import Whatsapp from '../../assets/whatsapp.png'
import Instagram from '../../assets/instagram.png'
import Facebook from '../../assets/facebook.png'
import Logo from '../../assets/logo.png'
import Location1 from '../../assets/location1.jpg'
import Location2 from '../../assets/location2.jpg'

const Footer = () => {
  // Replace these with your actual social media links
  const whatsappNumber = '917838255858';
  const instagramUrl = 'https://www.instagram.com/yourprofile';
  const facebookUrl = 'https://www.facebook.com/yourpage';

  return (
    <div className='Footer-container'>
      <hr />
      <div className="footer">
        <div className="social-links">
          {/* WhatsApp with direct chat link */}
          <a 
            href={`https://wa.me/${whatsappNumber}`} 
            target="_blank" 
            rel="noopener noreferrer"
            className="social-icon"
          >
            <img className='what' src={Whatsapp} alt="Chat with us on WhatsApp" />
          </a>
          
          {/* Instagram */}
          <a 
            href={instagramUrl}
            target="_blank" 
            rel="noopener noreferrer"
            className="social-icon"
          >
            <img className='insta' src={Instagram} alt="Follow us on Instagram" />
          </a>
          
          {/* Facebook */}
          <a 
            href={facebookUrl}
            target="_blank" 
            rel="noopener noreferrer"
            className="social-icon"
          >
            <img className='face' src={Facebook} alt="Like us on Facebook" />
          </a>
        </div>
        
        <div className="locations">
          <div className="location">
            <h4>Main Branch</h4>
            <a 
              href="https://maps.app.goo.gl/Ujxqsbh29SryQu599" 
              target="_blank" 
              rel="noopener noreferrer"
              className="location-link"
            >
              <p>123 Fitness Street, Gym District<br />
              New Delhi, India</p>
              <img 
                src={Location1} 
                alt="Main Branch Location" 
                className="location-image"
              />
            </a>
          </div>
          
          <div className="location">
            <h4>Second Branch</h4>
            <a 
              href="https://maps.app.goo.gl/ko2NfxiQxag1TrF86" 
              target="_blank" 
              rel="noopener noreferrer"
              className="location-link"
            >
              <p>456 Workout Avenue, Fitness Zone<br />
              Mumbai, India</p>
              <img 
                src={Location2} 
                alt="Second Branch Location" 
                className="location-image"
              />
            </a>
          </div>
        </div>
        
        <div className="logo-f">
          <img src={Logo} alt="Company Logo" />
        </div>
      </div>
      <div className="blur blur-f-1"></div>
      <div className="blur blur-f-2"></div>
    </div>
  )
}

export default Footer